module.exports = __webpack_public_path__ + "img/orgao-atos-icon-min.7f31e021.png";